// CleverTap event name
export const EVENT_NAME = {
  BNPL_ONBOARDING: "BNPL_ONBOARDING",
  OUTCOME_BNPL_REG_SUCCESS: "OUTCOME_BNPL_REG_SUCCESS"
};
